import http from "./http";
import Service from "../Service";

/**
 * Filtros salvos das listagens (kyojin /clients/saved-filters).
 */
export default class SavedFiltersService extends Service {
    list(screen) {
        return http.get(`clients/saved-filters`, {
            headers: this.getHeaders(),
            params: { screen },
        });
    }

    create(data) {
        return http.post(`clients/saved-filters`, data, {
            headers: this.getHeaders(),
        });
    }

    update(id, data) {
        return http.patch(`clients/saved-filters/${id}`, data, {
            headers: this.getHeaders(),
        });
    }

    remove(id) {
        return http.delete(`clients/saved-filters/${id}`, {
            headers: this.getHeaders(),
        });
    }
}
